<template>
  <div>
    <div class="demo-panel">
      <div class="demo-title">短信验证码</div>
      <div class="demo-content">
        <div class="bx-btn" @click="showSMS()">显示短信验证码</div>
      </div>
    </div>
  </div>
</template>
<script>
  import MessageBox from '@packages/components/messagebox/messagebox'
  export default {
    data () {
      return {}
    },
    methods: {
      showSMS: function () {
        MessageBox.SMS({
          onSend: function () {
            console.log('send');
          },
          onInput: function (value) {
            console.log(value);
          },
          onCancel: function () {
            console.log('cancel');
          },
          onSubmit: function () {
            console.log('submit');
            this.setWrong();
            // this.close();
          }
        });
      }
    },
    mounted: function () {
      // eslint-disable-next-line
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/MessageBox.vue